import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Title, Fieldset, Button, Control, Field } from "rbx";
import { useMutation } from "react-apollo";

import { CREATE_CUSTOMER_MUTATION } from "../../graphql/Customers/Customers.graphql";
import { ourToast as toast } from "../../utils";
import { useSystemCodes } from "../../utils/hooks";
import CustomerForm from "./CustomerForm";
import Loading from "../Loading";

const DEFAULT_STATE = {
  Name: "",
  Active: true,
  CustomerTypeRecIdRef: "",
  Address1: "",
  Address2: "",
  City: "",
  State: "",
  Zip: "",
  Telephone: "",
  FaxNo: "",
  BillingContactName: "",
  BillToCust: false,
  OrderCust: false,
  PaymentTermsRecIdRef: "",
  RevGLRecIdRef: "",
  ArGLRecIdRef: ""
};

const AddCustomer = ({ onComplete }) => {
  const [inputs, setInputs] = useState({ ...DEFAULT_STATE });
  const [codes, setCodes] = useState(null);
  const { data: systemCodes } = useSystemCodes({
    Category: "General Ledger",
    CodeName: "AcctType"
  });

  useEffect(() => {
    if (!codes && Array.isArray(systemCodes)) {
      setCodes({
        revenue: systemCodes?.find(c => c.CodeId === "R"),
        asset: systemCodes?.find(c => c.CodeId === "A")
      });
    }
  }, [codes, systemCodes]);

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({ ...inputs, [e.target.name]: value });
  };
  const [createCustomer, { loading }] = useMutation(CREATE_CUSTOMER_MUTATION, {
    refetchQueries: ["ALL_CUSTOMERS_QUERY"]
  });
  const handleSave = async e => {
    e.preventDefault();
    try {
      await createCustomer({
        variables: {
          data: {
            ...inputs,
            CustomerTypeRecIdRef: parseInt(inputs.CustomerTypeRecIdRef),
            PaymentTermsRecIdRef:
              inputs.PaymentTermsRecIdRef && inputs.BillToCust
                ? parseInt(inputs.PaymentTermsRecIdRef)
                : null,
            RevGLRecIdRef: inputs.RevGLRecIdRef
              ? parseInt(inputs.RevGLRecIdRef)
              : null,
            ArGLRecIdRef: inputs.ArGLRecIdRef
              ? parseInt(inputs.ArGLRecIdRef)
              : null
          }
        }
      });
      toast.success("Customer created successfully.");
      onComplete();
    } catch (err) {
      toast.error("Error creating Customer.");
    }
  };

  if (!codes) return <Loading />;
  return (
    <form
      className="add-customer-form"
      id="add-customer-form"
      style={{ minWidth: 1000, maxWidth: "95%" }}
      onSubmit={handleSave}
    >
      <Title>Create Customer</Title>
      <Fieldset disabled={loading}>
        <CustomerForm
          codeStates={codes}
          inputs={inputs}
          onChange={handleChange}
        />
        <hr />
        <Field kind="group">
          <Control>
            <Button color="primary" form="add-customer-form" type="submit">
              Submit
            </Button>
          </Control>
          <Control>
            <Button type="button" onClick={onComplete}>
              Cancel
            </Button>
          </Control>
        </Field>
      </Fieldset>
    </form>
  );
};

AddCustomer.propTypes = {
  onComplete: PropTypes.func
};
export default AddCustomer;
